module.exports = __webpack_public_path__ + "img/doreltaxi.5c72339c.webp";